import React from 'react';
import {
    Button
} from '@mui/material';

const DownloadCatalog = () => {
    const downloadCatalog = () => {
        const link = document.createElement('a');
        link.href = 'catalog.jpg';
        link.download = 'catalog.jpg';
        link.click();
    };

    return (
        <div>
            <Button variant="contained" color="primary" fullWidth onClick={downloadCatalog}>
                Download Catalog
            </Button>
            {/* <button onClick={downloadCatalog}>Download Catalog</button> */}
        </div>
    );
};

export default DownloadCatalog;
